import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  filter: {
    '=': [
      {
        '@.': '!id',
      },
      {
        '@$': 'subrecipientId',
      },
    ],
  },
  target: 'ent:!subrecips:!subrecip',
  quantity: 1,
  selection: {
    '{}': {
      name: 'Subrecipient Details',
      type: 'details',
      content: {
        '{}': {
          sections: {
            '[]': [
              {
                '{}': {
                  name: 'Subrecipient Information',
                  fields: {
                    '[]': [
                      {
                        '{}': {
                          meta: {
                            '{}': {
                              dmsAttr: {
                                '{}': {
                                  attributeId:
                                    'attr:ent#!subrecips#!subrecip:!code',
                                },
                              },
                            },
                          },
                          value: {
                            '@.': '!id',
                          },
                          readonly: true,
                        },
                      },
                      {
                        '{}': {
                          meta: {
                            '{}': {
                              dmsAttr: {
                                '{}': {
                                  attributeId:
                                    'attr:ent#!subrecips#!subrecip:!name',
                                },
                              },
                            },
                          },
                          value: {
                            '@.': '!name',
                          },
                          readonly: true,
                        },
                      },
                      {
                        '{}': {
                          meta: {
                            '{}': {
                              dmsAttr: {
                                '{}': {
                                  attributeId:
                                    'attr:ent#!subrecips#!subrecip:!descr',
                                },
                              },
                            },
                          },
                          value: {
                            '@.': '!descr',
                          },
                          readonly: true,
                        },
                      },
                      {
                        '{}': {
                          meta: {
                            '{}': {
                              dmsAttr: {
                                '{}': {
                                  attributeId:
                                    'attr:ent#!subrecips#!subrecip:!website',
                                },
                              },
                            },
                          },
                          value: {
                            '@.': '!website',
                          },
                          readonly: true,
                        },
                      },
                      {
                        '{}': {
                          meta: {
                            '{}': {
                              dmsAttr: {
                                '{}': {
                                  attributeId:
                                    'attr:ent#!subrecips#!subrecip:!primary_contact',
                                },
                              },
                            },
                          },
                          value: {
                            '@.': '!primary_contact',
                          },
                          readonly: true,
                        },
                      },
                    ],
                  },
                },
              },
              {
                '{}': {
                  name: 'Institution Information',
                  fields: {
                    '@': 'institution',
                  },
                  columnsCount: 2,
                },
              },
            ],
          },
        },
      },
      overflowActions: {
        '[]': [
          {
            '{}': {
              icon: 'atn-icon atn-edit atn-blue',
              name: 'Edit subrecipient overflow action',
              action: {
                '{}': {
                  payload: {
                    '{}': {
                      widget: {
                        '{}': {
                          alias: 'sr.subrecipients.widgets.edit-subrecipients',
                        },
                      },
                      variables: {
                        '{}': {
                          subrecipientId: {
                            '@.': '!id',
                          },
                        },
                      },
                    },
                  },
                  operation: 'ui.modal',
                },
              },
            },
          },
        ],
      },
    },
  },
  subqueries: {
    institution: {
      ref: {
        attr: 'attr:ent#!subrecips#!subrecip:!institution',
      },
      target: 'ent:!ext_institutions:!institution',
      selection: {
        '[]': [
          {
            '{}': {
              meta: {
                '{}': {
                  dmsAttr: {
                    '{}': {
                      attributeId:
                        'attr:ent#!ext_institutions#!institution:!code',
                    },
                  },
                },
              },
              value: {
                '@.': '!code',
              },
              readonly: true,
            },
          },
          {
            '{}': {
              meta: {
                '{}': {
                  dmsAttr: {
                    '{}': {
                      attributeId:
                        'attr:ent#!ext_institutions#!institution:!name',
                    },
                  },
                },
              },
              value: {
                '@.': '!name',
              },
              readonly: true,
            },
          },
          {
            '{}': {
              meta: {
                '{}': {
                  dmsAttr: {
                    '{}': {
                      attributeId:
                        'attr:ent#!ext_institutions#!institution:!ein',
                    },
                  },
                },
              },
              value: {
                '@.': '!ein',
              },
              readonly: true,
            },
          },
          {
            '{}': {
              meta: {
                '{}': {
                  dmsAttr: {
                    '{}': {
                      attributeId:
                        'attr:ent#!ext_institutions#!institution:!uei',
                    },
                  },
                },
              },
              value: {
                '@.': '!uei',
              },
              readonly: true,
            },
          },
          {
            '{}': {
              meta: {
                '{}': {
                  dmsAttr: {
                    '{}': {
                      attributeId:
                        'attr:ent#!ext_institutions#!institution:!sam_name',
                    },
                  },
                },
              },
              value: {
                '@.': '!sam_name',
              },
              readonly: true,
            },
          },
          {
            '{}': {
              meta: {
                '{}': {
                  dmsAttr: {
                    '{}': {
                      attributeId:
                        'attr:ent#!ext_institutions#!institution:!type',
                    },
                  },
                },
              },
              value: {
                '@.': '!type',
              },
              readonly: true,
            },
          },
        ],
      },
    },
  },
}
